import type { CreditsBalance, Customer } from '@leid/api-customers'
import { Response } from '@leid/client'

import { CompleteCustomerRequest } from 'appTypes/api-requests/customer'
import { RegisterFormValues } from 'appTypes/auth'
import apiClient from 'utils/apiClient'

export const customersApi = {
  async getCustomerBalance(customerId: number): Promise<CreditsBalance> {
    const result = await apiClient.get<Response<CreditsBalance>>(`/api/users/${customerId}/balance`)
    if (!result.data.success) {
      throw new Error('Error on get customer balance')
    }
    if (!result.data.data) {
      throw new Error('Customer balance not found')
    }

    return result.data.data
  },

  async getOrganizationBalance(organizationId: number): Promise<CreditsBalance> {
    const result = await apiClient.get<Response<CreditsBalance>>(`/api/organizations/${organizationId}/balance`)
    if (!result.data.success) {
      throw new Error('Error on get organization balance')
    }
    if (!result.data.data) {
      throw new Error('Organization balance not found')
    }

    return result.data.data
  },

  async getCustomerProfile(): Promise<Customer | null> {
    const result = await apiClient.get<Response<Customer>>(`/api/customers`)
    if (!result.data.success || !result.data.data) {
      throw new Error('Error on get customer')
    }
    return result.data.data ?? null
  },

  async updateCustomerProfile(values: Customer): Promise<void> {
    await apiClient.put(`/api/customers/${values.id}`, values)
  },

  async createCustomerProfile(registerFormValues: RegisterFormValues): Promise<Customer | null> {
    try {
      const result = await apiClient.post<Response<Customer | null>>('/api/customers', registerFormValues)
      return result.data?.data ?? null
    } catch (err) {
      return null
    }
  },

  async cleanupCustomerProfile(id: number): Promise<boolean | null> {
    try {
      const result = await apiClient.post<Response<boolean | null>>(`/api/customers/${id}/cleanup`)
      return result.data?.data ?? null
    } catch (err) {
      return null
    }
  },

  async completeCustomerProfile(id: number, request: CompleteCustomerRequest): Promise<Customer | null> {
    try {
      const result = await apiClient.post<Response<Customer | null>>(`/api/customers/${id}/complete`, request)
      return result.data?.data ?? null
    } catch (err) {
      return null
    }
  },
}
